import type { Connector } from '../shapes/Connector';
import type { Point } from '../state/types';
import { getFontString } from '../tools/textLayout';
import { COLORS, FONT_FAMILIES, PADDING } from '../../../config/constants';
import { getConnectorTextPosition } from './ConnectorGeometry';

export interface ConnectorLabelTheme {
  bgColor: string;
  textColor: string;
  borderColor: string;
}

export interface ConnectorLabelLayout {
  midPoint: Point;
  rect: { x: number; y: number; width: number; height: number };
  font: string;
  textX: number;
  textY: number;
}

export const getConnectorLabelTheme = (inverted: boolean): ConnectorLabelTheme => ({
  bgColor: inverted ? COLORS.connectorLabelLight : COLORS.connectorLabelDark,
  textColor: inverted ? COLORS.connectorLabelDark : COLORS.connectorLabelLight,
  borderColor: inverted ? COLORS.accentLight : COLORS.accent,
});

export const getConnectorLabelLayout = (
  ctx: CanvasRenderingContext2D,
  connector: Connector
): ConnectorLabelLayout => {
  const font = getFontString({
    fontSize: connector.textSize,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontFamily: FONT_FAMILIES.connector,
  });
  ctx.font = font;

  const metrics = ctx.measureText(connector.text);
  const padding = PADDING.connectorLabel;
  const textHeight = connector.textSize * 1.2;
  const midPoint = getConnectorTextPosition({
    startPoint: connector.startPoint,
    endPoint: connector.endPoint,
    waypoints: connector.waypoints,
    arcPoint: connector.arcPoint,
  });

  const rectX = midPoint.x - metrics.width / 2 - padding;
  const rectY = midPoint.y - textHeight / 2 - padding;
  const rectWidth = metrics.width + padding * 2;
  const rectHeight = textHeight + padding * 2;

  return {
    midPoint,
    rect: { x: rectX, y: rectY, width: rectWidth, height: rectHeight },
    font,
    textX: midPoint.x,
    textY: midPoint.y,
  };
};
